<template>
  <div>
    <transition-group name="flip-list" tag="ul" class="relative">
      <li
        appear
        v-for="item in data"
        :key="item.name"
        class="text-sm pt-1 pb-2 border-b border-transparent"
        :class="{
          'flex items-center': textLeft,
        }"
      >
        <div class="truncate" :class="{ 'w-24': textLeft }">
          <span class="bg-white">{{ item.name }}</span>
        </div>

        <transition-group
          name="flip-list"
          tag="div"
          class="flex h-7 rounded overflow-hidden"
          :class="{ 'space-x-4 md:space-x-8': !stacked, 'flex-grow': textLeft }"
          appear
        >
          <div
            v-for="(value, i) in item.values"
            :key="`${item.name}-${value.name}`"
            class="text-white h-full transition-all duration-500 transform rounded"
            :class="{ 'bg-gray-100': !stacked }"
            :style="{
              'will-change': 'transform, width',
              width: stacked ? `${value.value * max[i]}%` : `${100 / options}%`,
            }"
          >
            <!-- transform: !stacked
              ? i === options - 1
                ? `translateX(calc(-${100 *
                    (options - unknownIndexPosition - 1)}% - ${0.5 *
                    (options - unknownIndexPosition - 1)}rem))`
                : i >= unknownIndexPosition
                ? `translateX(calc(${100}% + 0.5rem))`
                : null
              : null, -->
            <div
              class="flex items-center justify-center h-full transition-all duration-500 bg-opacity-90"
              :class="{
                [colorClasses[value.name]]: true,
                rounded: !stacked,
              }"
              :style="{
                'will-change': 'width',
                width: stacked ? '100%' : `${(value.value * 100) / max[i]}%`,
              }"
              @mouseenter="showTooltip($event, value, item)"
              @mouseleave="hideTooltip"
            >
              <!-- <span
              v-show="
                !stacked ? (value.value * 100) / max[i] > 8 : value.value > 2
              "
              class="tabular-nums"
            >
              <TweeningNumber :num="value.value" :decimals="0" />%</span
            > -->
            </div>
          </div>
        </transition-group>
      </li>
    </transition-group>
    <VTooltip :show="tooltip.show" :target="tooltip.target" class="z-30">
      <div
        class="bg-black bg-opacity-80 text-white px-4 py-2 rounded-lg text-xs flex items-center"
      >
        <div class="">
          <div class="font-bold">{{ tooltip.title }}</div>
          <div>{{ tooltip.value }}%</div>
        </div>
      </div>
    </VTooltip>
  </div>
</template>

<script>
import { max } from "d3";
// import TweeningNumber from "@/components/TweeningNumber";
import VTooltip from "@/components/VTooltip";

export default {
  name: "StackedBarChart",
  components: { VTooltip },
  props: {
    data: {
      type: Array,
      default: () => [
        {
          name: "Data 1",
          values: [
            { name: "val 1", value: 60 },
            { name: "val 2", value: 40 },
          ],
        },
        {
          name: "Data 2",
          values: [
            { name: "val 1", value: 30 },
            { name: "val 2", value: 70 },
          ],
        },
      ],
    },
    selected: {
      type: String,
      default: null,
    },
    activeClass: {
      type: String,
      default: "",
    },
    barClass: {
      type: String,
      default: "bg-gray-300",
    },
    compareClass: {
      type: String,
      default: "bg-gray-600 bg-opacity-50",
    },
    colorClasses: {
      type: Object,
      default: () => ({ "val 1": "bg-blue-500", "val 2": "bg-yellow-500" }),
    },
    stacked: {
      type: Number,
      default: 0,
    },
    unknownIndexPosition: {
      type: Number,
      default: 2,
    },
    textLeft: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tooltip: {
        show: false,
        value: 0,
        title: "",
        target: null,
      },
    };
  },
  computed: {
    max() {
      if (this.stacked) return this.data[0].values.map(() => 1);

      const maximums = [];
      this.data.forEach((e) => {
        e.values.forEach((e, i) => {
          if (!maximums[i]) maximums[i] = [];
          maximums[i].push(e.value);
        });
      });

      return maximums.map((e) => max(e) || 1);
    },
    options() {
      return this.data[0].values.length;
    },
  },
  methods: {
    showTooltip({ target }, value) {
      this.hover = value.name;
      this.tooltip.target = target;
      this.tooltip.value = value.value;
      this.tooltip.title =
        value.name === "value" ? "Pacientes" : "Población general";
      this.tooltip.show = true;
    },
    hideTooltip() {
      this.hover = null;
      this.tooltip.show = false;
    },
  },
};
</script>
